var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9766 5.5H7.02344C6.18341 5.5 5.5 6.18341 5.5 7.02344V16.9766C5.5 17.8166 6.18341 18.5 7.02344 18.5H16.9766C17.8166 18.5 18.5 17.8166 18.5 16.9766V7.02344C18.5 6.18341 17.8166 5.5 16.9766 5.5ZM17.4844 16.9766C17.4844 17.2566 17.2566 17.4844 16.9766 17.4844H14.082V13.3457H15.6509L15.9102 11.7715H14.082V10.6797C14.082 10.2487 14.4127 9.91797 14.8438 9.91797H15.8848V8.34375H14.8438C13.5508 8.34375 12.5084 9.39111 12.5084 10.6841V11.7715H10.9844V13.3457H12.5084V17.4844H7.02344C6.74343 17.4844 6.51562 17.2566 6.51562 16.9766V7.02344C6.51562 6.74343 6.74343 6.51562 7.02344 6.51562H16.9766C17.2566 6.51562 17.4844 6.74343 17.4844 7.02344V16.9766Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.dc4e61f63d08603d1c7953ef6f592481.svg";
export { ForwardRef as ReactComponent };